import { createGlobalStyle } from 'styled-components';

import { createScrollbarCss } from '@sternum/web/utils';

import { Colors } from './components/theme/constants';

export const GlobalCss = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: Fellix, Arial, Helvetica, sans-serif;
    font-size: 12px;
    color: ${(props) => props.theme.textColor};
    background: ${(props) => (props.theme.mainThemeMode === 'Dark' ? Colors.Darkest : Colors.Lightest)};

    ${createScrollbarCss({
      Dark: { background: 'transparent', thumbBackground: Colors.GreyLighter },
      Light: { background: 'transparent', thumbBackground: Colors.GreyDarker },
    })}
  }

  html, body, #root {
    height: 100%;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Fellix, Arial, Helvetica, sans-serif;
  }

  .sternum-dark-mode {
    background: ${Colors.Black};
  }
`;
